export const fieldConfig = {
  basicInfo: {
    tour_name: {
      label: "Tour Name",
      placeholder: "Enter the name of your tour",
      helperText: "Give your tour a catchy name",
    },
    description: {
      label: "Tour Description",
      placeholder: "Briefly describe your tour highlights",
      helperText: "What makes your tour special? Include key attractions",
    },
    country: {
      label: "Country",
      placeholder: "Country where the tour takes place",
      helperText: "E.g., United States, France, Japan",
    },
    state: {
      label: "State/Province",
      placeholder: "State or province if applicable",
      helperText: "E.g., California, Île-de-France",
    },
    city: {
      label: "City",
      placeholder: "City where the tour starts or is centered",
      helperText: "E.g., New York, Paris",
    },
    duration: {
      label: "Duration (days)",
      placeholder: "Number of days for the tour",
      helperText: "How long does your tour last?",
    },
  },

  itinerary: {
    day: {
      label: "Day Number",
      placeholder: "Enter the day number of the itinerary",
      helperText: "E.g., Day 1, Day 2",
    },
    title: {
      label: "Title",
      placeholder: "Enter the title of the day",
      helperText: "E.g., Arrival, City Tour, Free Day",
    },
    description: {
      label: "Description",
      placeholder: "Describe the activities for the day",
      helperText: "What will happen on this day? Include key activities.",
    },
    location: {
      label: "Location",
      placeholder: "Enter the location for the day",
      helperText: "Where does this activity take place? E.g., Paris, London.",
    },
    startTime: {
      label: "Start Time",
      placeholder: "Enter the start time for the activity",
      helperText: "E.g., 9:00 AM",
    },
    endTime: {
      label: "End Time",
      placeholder: "Enter the end time for the activity",
      helperText: "E.g., 6:00 PM",
    },
  },

  pricing: {
    pricePerPerson: {
      label: "Price Per Person",
      placeholder: "Enter the price per person for the tour",
      helperText: "This will be the price each traveler will pay",
    },
    currency: {
      label: "Currency",
      placeholder: "Select the currency for the price",
      helperText: "Choose the currency in which the price will be displayed",
    },
    discountValue: {
      label: "Discount Value",
      placeholder: "Enter the discount value (if any)",
      helperText: "E.g., 10% off or $50 off",
    },
    minGroupSize: {
      label: "Minimum Group Size",
      placeholder: "Enter the minimum group size for the discount",
      helperText: "E.g., 5 people are required to avail the discount",
    },
  },

  availability: {
    startDate: {
      label: "Start Date",
      placeholder: "Select the start date for availability",
      helperText: "The date when availability starts",
    },
    endDate: {
      label: "End Date",
      placeholder: "Select the end date for availability",
      helperText: "The date when availability ends",
    },
    minGuests: {
      label: "Min Guests",
      placeholder: "Enter the minimum number of guests",
      helperText: "The minimum number of guests required for this availability",
    },
    maxGuests: {
      label: "Max Guests",
      placeholder: "Enter the maximum number of guests",
      helperText: "The maximum number of guests allowed for this availability",
    },
    isAvailable: {
      label: "Is Available",
      helperText: "Toggle to set this availability as active or inactive",
    },
  },

  additional: {
    requirements: {
      label: "Tour Requirements",
      placeholder: "Provide any additional requirements for the tour",
      helperText: "Enter any requirements like health or special requests.",
    },
    cancellationPolicy: {
      label: "Cancellation Policies",
      placeholder: "Provide details on cancellation policies",
      helperText: "Describe the tour cancellation policy clearly.",
    },
    contact: {
      name: {
        label: "Name",
        placeholder: "Enter the contact name",
        helperText: "This is the primary contact person for the tour",
      },
      phone: {
        label: "Phone",
        placeholder: "Enter the contact phone number",
        helperText: "This is the contact phone number for inquiries.",
      },
      email: {
        label: "Email",
        placeholder: "Enter the contact email",
        helperText: "This is the contact email for inquiries.",
      },
    },
    tags: {
      label: "Tags",
      placeholder: "Add relevant tags for the tour",
      helperText: "Use tags to categorize or describe the tour.",
    },
  },
};
